import { Pipe, PipeTransform } from '@angular/core';
import isEmpty from 'lodash-es/isEmpty';

import { ReservationItems, ReservationType, UserHistoryItem } from '@user-history/entities/user-history-item';
import { isPackageAirReservation, isTravelExtraReservation } from '@user-history/mappers/user-history.mapper';
import { generateAirPackageReservationCode } from '@user-history/mappers/air-package-reservation-code.mapper';
import { getReservationItemByExtra, getDetaultExtraItem } from '@app/pipes/mappers/reservation-items.mapper';
import { mapperReferenceCode } from '@user-history/mappers/flight-reservations.mapper';

@Pipe({
  name: 'userHistoryFormat',
  standalone: false
})
export class UserHistoryFormatPipe implements PipeTransform {

  constructor() { }

  transform(history: UserHistoryItem[]): UserHistoryItem[] {
    const historyFormat = history.map((item: UserHistoryItem) => {
      if (isPackageAirReservation(item)) {
        const airItem = item.ReservationItems.find(reservation => reservation.ReservationItemType === ReservationType.Flight);
        const hotelItem = item.ReservationItems.find(reservation => reservation.ReservationItemType === ReservationType.Hotel);
        const assistanceItem = item.ReservationItems.find(res => res.ReservationItemType === ReservationType.Assistance);
        return {
          ...item,
          ReservationItems: [
            {
              ...airItem,
              ConfirmationNumber: generateAirPackageReservationCode(
                mapperReferenceCode(formatAirlineCode(airItem.Description), airItem.ConfirmationNumber),
                hotelItem.ConfirmationNumber),
              ReservationItemType: ReservationType.AirPackage,
              ImageUrl: hotelItem.ImageUrl ? hotelItem.ImageUrl : airItem.ImageUrl,
              Description: hotelItem.Description,
              AirlineCode: formatAirlineCode(airItem.Description)
            },
            {
              ...assistanceItem
            }
          ]
        };
      } else if (isTravelExtraReservation(item)) {
        const productItem = getReservationItemByExtra(item) ?? {} as ReservationItems;
        const assistanceItem = item.ReservationItems.find(res => res.ReservationItemType === ReservationType.Assistance);
        let airlineCode = '';
        let extraItemDescription = '';
        let airTripType = null;
        let company = null;
        if (
          productItem.ReservationItemType === ReservationType.Flight ||
          productItem.ReservationItemType === ReservationType.Bus
        ) {
          airlineCode = formatAirlineCode(productItem.Description);
          airTripType = productItem.AirTripType;
        }
        if (productItem.ReservationItemType === ReservationType.Auto) {
          extraItemDescription = productItem.Model;
          company = productItem.Company;
        } else extraItemDescription = productItem.Description;
        return {
          ...item,
          ReservationItems: [
            {
              ...getDetaultExtraItem(item),
              ConfirmationNumber: mapperReferenceCode(airlineCode, item.ReservationItems[0]?.ConfirmationNumber),
              ReservationItemType: ReservationType.Extra,
              ImageUrl: productItem.ImageUrl || '',
              AirlineCode: airlineCode,
              ExtraReservationType: productItem.ReservationItemType,
              ExtraReservationDescription: extraItemDescription,
              AirTripType: airTripType,
              Company: company,
              AllExtrasDescription: item.ReservationItems
                .filter(res => res.ReservationItemType === ReservationType.Extra)
                .map(extra => extra.Description)
            },
            {
              ...assistanceItem
            }
          ].filter(_item => !isEmpty(_item))
        };
      } else {
        return {
          ...item,
          ReservationItems: item.ReservationItems.map((reservation, index) => {
            const description = reservation.Description || item.ReservationItems[0]?.Description;
            const confirmationNumber = reservation.ConfirmationNumber || item.ReservationItems[0]?.ConfirmationNumber;
            if (
              reservation.ReservationItemType === ReservationType.Flight ||
              reservation.ReservationItemType === ReservationType.Bus
            ) {
              return {
                ...reservation,
                AirlineCode: formatAirlineCode(description),
                ConfirmationNumber:
                  mapperReferenceCode(formatAirlineCode(description), confirmationNumber),
              };
            } else return reservation;
          })
        };
      }
    });
    return historyFormat;
  }

}

function formatAirlineCode(description: string): string {
  return description?.split(',')?.[0]?.split('-')?.[0]?.replace(' ', '')?.replace(' ', '');
}
